import { RegExpMatcher, TextCensor, englishDataset, englishRecommendedTransformers } from 'obscenity'

// Create matcher for profanity detection
const matcher = new RegExpMatcher({
  ...englishDataset.build(),
  ...englishRecommendedTransformers,
})

// Create censor for cleaning text
const censor = new TextCensor()

export function containsProfanity(text: string): boolean {
  return matcher.hasMatch(text)
}

export function cleanText(text: string): string {
  const matches = matcher.getAllMatches(text)
  return censor.applyTo(text, matches)
}

export function moderateComment(text: string): { 
  isAllowed: boolean, 
  cleanedText: string, 
  reason?: string 
} {
  // Check for profanity
  if (containsProfanity(text)) {
    return {
      isAllowed: false,
      cleanedText: cleanText(text),
      reason: 'Contains inappropriate language'
    }
  }

  // Check for other issues (length, etc.)
  if (text.length > 500) {
    return {
      isAllowed: false,
      cleanedText: text,
      reason: 'Comment too long (max 500 characters)'
    }
  }

  return {
    isAllowed: true,
    cleanedText: text
  }
} 